import { render, staticRenderFns } from "./OtherLabourView.vue?vue&type=template&id=e7980afc"
import script from "./OtherLabourView.vue?vue&type=script&lang=js"
export * from "./OtherLabourView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports